import React from 'react';

interface BadgeProps {
    children: React.ReactNode;
    color?: 'blue' | 'green' | 'yellow' | 'red' | 'purple' | 'gray';
    size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({
    children,
    color = 'gray',
    size = 'sm'
}) => {
    const colors = {
        blue: { bg: '#e3f2fd', text: '#1e3a5f' },
        green: { bg: '#e8f5e9', text: '#5a7a6a' },
        yellow: { bg: '#fff8e1', text: '#8b6914' },
        red: { bg: '#ffebee', text: '#8b4513' },
        purple: { bg: '#f3e5f5', text: '#5a5a5a' },
        gray: { bg: '#f5f5f5', text: '#5a5a5a' },
    };

    const sizes = {
        sm: { fontSize: '11px', padding: '2px 8px' },
        md: { fontSize: '13px', padding: '4px 12px' },
    };

    const style = {
        display: 'inline-block',
        borderRadius: '20px',
        fontWeight: 'bold',
        ...colors[color],
        ...sizes[size],
    };

    return <span style={style}>{children}</span>;
};